var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"book-view-toggle"},[_c('div',{class:{
      'book-view-button': true,
      active: _vm.$store.state.ui.mode !== 'book-view'
    },on:{"click":function($event){return _vm.$store.dispatch('setMode', 'normal')}}},[_vm._v(" map ")]),_c('div',{class:{
      'book-view-button': true,
      active: _vm.$store.state.ui.mode === 'book-view'
    },on:{"click":function($event){return _vm.$store.dispatch('setMode', 'book-view')}}},[_vm._v(" focus ")])])}
var staticRenderFns = []

export { render, staticRenderFns }